import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

const columnData = [
	{
		id: 'name',
		numeric: false,
		disablePadding: false,
		label: 'Location',
	},
	{
		id: 'messagesThisBillingPeriod',
		numeric: true,
		disablePadding: true,
		label: 'Messages',
	},
	{
		id: 'lastUsedDate',
		numeric: false,
		disablePadding: false,
		label: 'Last Active',
	},
	{
		id: 'initialRating',
		numeric: true,
		disablePadding: true,
		label: 'Initial Rating',
	},
	{
		id: 'starRating',
		numeric: true,
		disablePadding: true,
		label: 'Current Rating',
	},
	{
		id: 'totalReviews',
		numeric: true,
		disablePadding: true,
		label: 'Total Reviews',
	},
	{
		id: 'newReviews',
		numeric: true,
		disablePadding: true,
		label: 'New Reviews',
	},
	{
		id: 'percentIncrease',
		numeric: true,
		disablePadding: true,
		label: 'Growth %',
	},
	{
		id: 'rrLast30Days',
		numeric: true,
		disablePadding: true,
		label: 'Recent Requests',
	},
	{
		id: 'rrTotal',
		numeric: true,
		disablePadding: true,
		label: 'Total Requests',
	},
];

class EnhancedTableHead extends React.Component {
	createSortHandler = (property) => (event) => {
		this.props.onRequestSort(event, property);
	};

	render() {
		const { order, orderBy } = this.props;

		return (
			<TableHead>
				<TableRow>
					{columnData.map((column) => (
						<TableCell
							key={column.id}
							numeric={column.numeric}
							padding={column.disablePadding ? 'none' : 'default'}
							align={column.numeric ? 'right' : 'left'}
							sortDirection={
								orderBy === column.id ? order : false
							}
						>
							<TableSortLabel
								active={orderBy === column.id}
								direction={order}
								onClick={this.createSortHandler(column.id)}
							>
								{column.label}
							</TableSortLabel>
						</TableCell>
					))}
				</TableRow>
			</TableHead>
		);
	}
}

EnhancedTableHead.propTypes = {
	onRequestSort: PropTypes.func.isRequired,
	order: PropTypes.string.isRequired,
	orderBy: PropTypes.string.isRequired,
};

export default EnhancedTableHead;



// WEBPACK FOOTER //
// ./src/components/chekkit/EnhancedTableHead.js